import { Accordion } from '../../design-system/index.js'
import { sectionGap, wrap } from '../layout.js'
import SectionHead from './SectionHead.jsx'

/** Questions, with the heading held in its own column beside them. */
export function Faq({ t, desktop }) {
  return (
    <section
      id="faq"
      aria-labelledby="faq-title"
      style={{
        ...wrap(desktop),
        paddingTop: sectionGap(desktop),
        display: desktop ? 'grid' : 'block',
        gridTemplateColumns: desktop ? '0.85fr 1.15fr' : undefined,
        gap: 56,
        alignItems: 'start',
      }}
    >
      <SectionHead
        id="faq-title"
        label={t.faqLabel}
        title={t.faqTitle}
        sub={t.faqSub}
        desktop={desktop}
        align="start"
      />
      <Accordion
        style={{ marginTop: desktop ? 0 : 24 }}
        items={t.faq.map(([q, a]) => ({ q, a }))}
      />
    </section>
  )
}

export default Faq
